<span matTooltip="Download ITT ({{ assetType === 'post-asset' ? 'Post Assets' : assetType === 'shoot-asset' ? 'Shoot Assets' : 'Output Assets' }})">
  @if (authService.hasPermission(Permission.ProductsLabelData)) {
    <button
      mat-icon-button
      class="apply-enhancement"
      (click)="onDownload()"
      >
      <div class="icon-wrapper">
        <mat-icon class="icon icon-a">text_snippet</mat-icon>
        <mat-icon class="icon icon-b">download</mat-icon>
      </div>
    </button>
  }
</span>
